import api, { getApiData, isPlainObject } from '../utils/api';

export const MANUAL_LOGOUT_KEY = 'auth_manual_logout';

export function isEnabledRoleFlag(value) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    return ['true', '1', 'yes'].includes(value.trim().toLowerCase());
  }
  return false;
}

export async function loginUser(username, password) {
  const response = await api.post('/login', { username, password });
  const data = getApiData(response, {});
  const token = typeof data?.token === 'string' ? data.token : '';
  const user = isPlainObject(data?.user) ? data.user : null;

  if (!token || !user) {
    throw new Error('Invalid login response received.');
  }

  localStorage.setItem('auth_token', token);
  localStorage.setItem('user_data', JSON.stringify(user));
  localStorage.removeItem(MANUAL_LOGOUT_KEY);
  return user;
}

export function logoutUser() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user_data');
  localStorage.removeItem('selected_employee');
  sessionStorage.clear();
  localStorage.setItem(MANUAL_LOGOUT_KEY, '1');
}

export function getCurrentUser() {
  const data = localStorage.getItem('user_data');
  if (!data) return null;
  try {
    const parsed = JSON.parse(data);
    return isPlainObject(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return !!localStorage.getItem('auth_token');
}
